import { render, staticRenderFns } from "./RolePagesDialog.vue?vue&type=template&id=40999340&"
import script from "./RolePagesDialog.vue?vue&type=script&lang=js&"
export * from "./RolePagesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports